export default __webpack_public_path__ + "static/media/pwm-positive.1bb77d38.svg";